var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlatTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 3 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -2.623,
    x2: 0,
    y1: 986.67,
    id: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: -2.623,
    x2: 0,
    y1: 986.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef4ab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.99997 0 0 1.99997-10.994-2071.68)",
    fill: "#da4453"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1037.36,
    x: 7,
    height: 8,
    width: 8,
    fill: "#32c671",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.86 12.966l-11.08-11.08c-1.52-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-53.45 53.53-23.953-24.04c-1.521-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-11.08 11.08c-1.521 1.521-2.281 3.368-2.281 5.541 0 2.172.76 4.02 2.281 5.54l29.493 29.493 11.08 11.08c1.52 1.521 3.367 2.281 5.54 2.281 2.172 0 4.02-.761 5.54-2.281l11.08-11.08 58.986-58.986c1.52-1.521 2.281-3.368 2.281-5.541.0001-2.172-.761-4.02-2.281-5.54",
    fill: "#fff",
    transform: "matrix(.0436 0 0 .0436 8.177 1039.72)",
    stroke: "none",
    strokeWidth: 9.512
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatTickIcon);
export default __webpack_public_path__ + "static/media/Flat_tick_icon.0e6874704c6d9c9d08cac1cdad1fbf68.svg";
export { ForwardRef as ReactComponent };